import { AnalyticsTypes } from 'src/middleware/google-analytics';
import { HttpStatusCodes, BookingStateProperties } from '../constants';
import { APPOINTMENT_INFO_GA_CATEGORY } from '../pages/AppointmentInfo/constants';
import bookingStateSelector from '../selectors/BookingStateSelector';
import patientSelector from '../selectors/PatientSelector';
import reviewAndBookScanCardStateSelector from '../selectors/ReviewAndBookScanInsuranceCardSelector';
import { stringifyIdsFromBody } from '../utils/bodyIdTransform';
import { ServerException } from './constants';

export const InsuranceCardFetchActions = {
    SUCCESS: '@@ic/CARDS_SUCCESS',
    FAILED: '@@ic/CARDS_FAILED',
    SCANNED_CARD_SUCCESS: '@@ic/CARDS_R&B_SCANNED_CARD_SUCCESS',
};

const apiHost = process.env.API_HOST || '';

const fetchInsuranceCards = async (patientId, state) => {
    const bookingState = bookingStateSelector(state);
    const scanCardState = reviewAndBookScanCardStateSelector(state);

    const reviewAndBookScanInsuranceCardIceToken =
        scanCardState.scannedIceRequestToken;

    const iceToken =
        reviewAndBookScanInsuranceCardIceToken ||
        (bookingState
            ? bookingState[BookingStateProperties.iceRequestToken]
            : null);

    let url = `${apiHost}/insurance/v2/cards?patient_id=${patientId}`;

    if (iceToken) {
        url += `&ice_request_token=${iceToken}`;
    }

    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
    });

    const body = await response.json();

    if (response.status !== HttpStatusCodes.OK || !body.length) {
        return {
            status: response.status,
            body: [],
        };
    }

    return {
        status: response.status,
        body: body.map(stringifyIdsFromBody),
    };
};

const parseCard = (card) => ({
    ...card,
    id: card.id.toString(),
    patientId: (card.patient_id || '').toString(),
    memberId: (card.member_id || '').toString(),
    planId: (card.plan_id || '').toString(),
    images: card.images,
    iceRequestToken: (card.ice_request_token || '').toString(),
});

export function getInsuranceCards(fromReviewAndBookCardScanner = false) {
    return async (dispatch, getState) => {
        const state = getState();
        const { patientId, insuranceCards } = patientSelector(state);

        if ((insuranceCards && !fromReviewAndBookCardScanner) || !patientId) {
            return;
        }

        try {
            const response = await fetchInsuranceCards(patientId, state);
            if (response.status !== 200) {
                throw new ServerException({
                    message: `Unhandled Status Code: ${response.status}`,
                });
            }

            const parsedCards = response.body.map(parseCard);

            dispatch({
                type: fromReviewAndBookCardScanner
                    ? InsuranceCardFetchActions.SCANNED_CARD_SUCCESS
                    : InsuranceCardFetchActions.SUCCESS,
                payload: {
                    patientId,
                    cards: parsedCards,
                },
                meta: {
                    analytics: {
                        type: AnalyticsTypes.TrackEvent,
                        category: APPOINTMENT_INFO_GA_CATEGORY,
                        action: `Insurance Card -${
                            fromReviewAndBookCardScanner
                                ? ' R&B Scanned Card '
                                : ' '
                        }Fetch Succeeded`,
                    },
                },
            });
        } catch (exception) {
            dispatch({
                type: InsuranceCardFetchActions.FAILED,
                meta: {
                    analytics: {
                        type: AnalyticsTypes.TrackEvent,
                        category: APPOINTMENT_INFO_GA_CATEGORY,
                        action: `Insurance Card -${
                            fromReviewAndBookCardScanner
                                ? ' R&B Scanned Card '
                                : ' '
                        }Fetch Failed`,
                    },
                },
            });
            throw exception;
        }
    };
}
